import LocalDataGrid from "@/components/DataGrid/LocalDataGrid";
import { useMemo } from "react";
import { GetTripFilesResObj, TripFileObj } from "@/types/interfaces/crm";
import filesColumns from "./columns";
import { getAdminTripFiles } from "@/services/api/crm/files";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import Loader from "@/components/Loader/Loader";
import ErrorFallback from "@/components/ErrorFallback/ErrorFallback";

interface Props {
  queryClient: UseQueryResult<GetTripFilesResObj>;
}

const Files = ({ queryClient }: Props) => {
  const columns = useMemo(() => filesColumns, []);
  const files: TripFileObj[] = queryClient.data?.files || [];

  if (queryClient.isLoading) {
    return <Loader />;
  }

  if (queryClient.isError) {
    return <ErrorFallback retry={queryClient.refetch} />;
  }

  return (
    <LocalDataGrid
      idProperty="fileId"
      columnDefs={columns}
      rowData={files}
      hideCsvExport
      hidePagination
      rowHeight={55}
      sortable
      emptyText="No data found"
    />
  );
};

export default Files;
